<template>
  <aside
    class="rg-navigation">

    <!-- Navigation Set Controls -->
    <!-- <div class="rg-list horizontal">
      <div
        class="set-selector">
        <i v-if="isDrawerOpen" aria-hidden="true" class="rg-icon material-icons">arrow_right</i>
        <i v-else aria-hidden="true" class="rg-icon material-icons">arrow_left</i>
      </div>
      <div
        class="rg-list-tile"
        v-for="(control, i) in navigationSetControls"
        :key="'setControl'+i"
        @click="toggleSetControl(control)"
        :class="{ 'rg-tile-active': control.active }">
        <div class="rg-list-tile-action rg-loader-icon">
          <span
            class="rg-loaded-icon"
            v-html="control.icon">
          </span>
          <span class="rg-navigation-label">
            {{ control.label }}
          </span>
        </div>
      </div>
    </div> -->

    <div class="rg-list">
      <!-- Reader View Control -->
      <!-- v-ripple -->
      <!-- <div
        class="rg-list-tile rg-tile-active"
        v-if="siteMeta.hasReader"
        @click="openReaderView()">
        <div class="rg-list-tile-action rg-loader-icon">
          <span
            class="rg-overlay"
            v-show="false">
          </span>
          <span class="rg-loaded-icon">
            <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path fill-opacity=".01" fill="#FFF" d="M0 0h40v40H0z"/><circle fill="#FFF" cx="20" cy="20" r="18"/><path d="M20 38c-9.941 0-18-8.059-18-18S10.059 2 20 2s18 8.059 18 18-8.059 18-18 18zm10.593-26.956c-2.284.13-6.822.601-9.624 2.316a.64.64 0 0 0-.303.549V29.07c0 .481.526.785.97.562 2.883-1.45 7.052-1.847 9.113-1.955.704-.037 1.25-.601 1.25-1.277V12.323c.001-.738-.639-1.323-1.406-1.28zM19.03 13.36c-2.8-1.715-7.34-2.186-9.623-2.316C8.64 11 8 11.585 8 12.323V26.4c0 .677.547 1.24 1.25 1.277 2.063.109 6.234.505 9.116 1.957.443.223.967-.081.967-.561V13.9c0-.22-.109-.422-.303-.541z" fill="#AC997C"/></g></svg>
          </span>
          <span class="rg-navigation-label">
            News Reader
          </span>
        </div>
        <div class="rg-tile-content">
          <div class="rg-tile-title caption">Twitter News Updates from:</div>
          <div class="rg-tile-sub-title caption">
            @EmergencyInfoBC, @BCGovFireInfo &amp; @DriveBC
          </div>
        </div>
      </div> -->

      <!-- Geolocation Control -->
      <div
        class="rg-list-tile rg-tile-active"
        v-if="hasGeolocation"
        @click="geoLocate()">
        <div class="rg-list-tile-action rg-loader-icon">
          <span
            class="rg-overlay"
            v-show="isGeolocating">
            <img src="static/loader-icon.svg"/>
          </span>
          <span
            v-if="!isGeolocationError"
            class="rg-loaded-icon">
            <img src="static/icons/locate-icon.svg" />
          </span>
          <span v-else
            class="rg-loaded-icon">
            <img src="static/error-icon.svg"/>
          </span>
          <span class="rg-navigation-label">
            Near Me
          </span>
        </div>
        <div class="rg-tile-content">
          <div class="rg-tile-title caption">Near Me:</div>
          <div class="rg-tile-sub-title caption">Zoom's the map to your location.</div>
        </div>
      </div>

      <!-- Navigation Controls -->
      <!-- v-ripple -->
        <div
          class="rg-list-tile"
          v-for="(control, i) in navigation"
          :key="i"
          :class="[{'rg-tile-active': control.active}, {'is-set-control': control.isSetControl}]">
          <!-- v-on:contextmenu="contextmenuHandler" -->
          <div
            class="rg-list-tile-action rg-loader-icon"
            @click="toggleControl(control)">
            <span
              class="rg-overlay"
              v-show="control.loadState === 'loading'">
              <img src="static/loader-icon.svg"/>
            </span>
            <span
              class="rg-loaded-icon"
              v-if="control.loadState !== 'error'"
              v-html="control.icon">
            </span>
            <span
              v-if="control.loadState === 'error'"
              class="rg-loaded-icon">
              <img src="static/error-icon.svg"/>
            </span>
            <span class="rg-navigation-label">
              {{ control.label }}
            </span>
          </div>

          <div class="rg-tile-content">
            <div class="rg-tile-title caption">{{control.legendText}}</div>
            <div
              :style="{ opacity: control.opacity}"
              class="rg-tile-sub-title" v-html="control.legendContent"></div>
            <div
              v-if="!control.isGroupControl && !control.isSetControl"
              :style="{ opacity: control.opacity}"
              class="slider-container">
              <input class="slider"
              :value="control.opacity"
              @input="evt => updateOpacity(control.id, evt.target.value)"
              type="range" min="0.25" max="1" step="0.01" />
            </div>
          </div>
        </div>

        <div
          class="rg-list-tile rg-tile-active"
          @click="openAboutView()">
          <div class="rg-list-tile-action rg-loader-icon">
            <span
              class="rg-overlay"
              v-show="false">
            </span>
            <span class="rg-loaded-icon">
              <img src="static/icons/about-icon.svg" />
            </span>
            <span class="rg-navigation-label">
              About
            </span>
          </div>
          <div class="rg-tile-content">
            <div class="rg-tile-title caption">About This Map</div>
            <div class="rg-tile-sub-title caption"></div>
          </div>
        </div>
      </div>
  </aside>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'NavigationView',

  data() {
    return {
      priorDrawerState: false,
      hasGeolocation: false,
      isGeolocating: false,
      isGeolocationError: false,
      loaderErrorIcon: `
      <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path fill-opacity=".01" fill="#FFFFFF" d="M0 0h40v40H0z"/>
          <path d="M38 20.124c0-9.872-8.003-17.876-17.876-17.876-9.872 0-17.876 8.004-17.876 17.876C2.248 29.997 10.252 38 20.124 38A17.876 17.876 0 0 0 38 20.124" fill="#FFFFFF" fill-rule="nonzero"/>
          <path d="M15.607 2.824l.867 17.344c.042.824.722 1.471 1.546 1.471h4.28c.824 0 1.504-.647 1.545-1.47l.866-17.327C32.361 4.868 38 11.837 38 20.124A17.876 17.876 0 0 1 20.124 38c-9.872 0-17.876-8.003-17.876-17.876 0-8.312 5.674-15.3 13.36-17.3zm9.712 26.039a5.166 5.166 0 0 0-5.16-5.16A5.166 5.166 0 0 0 15 28.863a5.166 5.166 0 0 0 5.16 5.16 5.166 5.166 0 0 0 5.16-5.16z" fill="#D65353" fill-rule="nonzero"/>
        </g>
      </svg>`,
    };
  },

  created() {
    this.$bus.$on('map-has-geolocated', this.hasGeolocatedHandler);
    this.$bus.$on('map-geolocation-error', this.geolocationErrorHandler);
  },

  beforeDestroy() {
    this.$bus.$off('map-has-geolocated');
    this.$bus.$off('map-geolocation-error');
  },

  computed: {
    ...mapState([
      'navigationState',
      'siteMeta',
      'isReaderViewAvailable',
      'isReaderViewVisible',
      'isDrawerOpen',
      'activeNavigationSet',
    ]),
    ...mapGetters([
      'getNavigationControlById',
    ]),
    navigation() {
      // eslint-disable-next-line max-len
      const returnNavigaiton = this.navigationState.filter(navigationItem => navigationItem.navigation && !navigationItem.isSetControl);
      returnNavigaiton.sort((a, b) => a.zindex - b.zindex);
      return returnNavigaiton;
    },

    groupControls() {
      // eslint-disable-next-line max-len
      return this.navigationState.filter(navigationItem => navigationItem.navigation && navigationItem.isGroupControl);
    },

    // notPartOfNavigationSet() {
    //   return this.navigationState.filter((navigationItem) => {
    //     let isPartOfActiveSet = false;
    //     if (navigationItem.setTags) {
    //       isPartOfActiveSet = navigationItem.setTags.includes(this.activeNavigationSet);
    //     }
    //     return navigationItem.navigation && !navigationItem.isSetControl && !isPartOfActiveSet;
    //   });
    // },

    // navigationSetControls() {
    //   return this.navigationState.filter((navigationItem) => {
    //     return navigationItem.isSetControl;
    //   });
    // },
  },

  mounted() {
    let hasGeolocation = ('geolocation' in navigator);
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') !== -1) {
      if (ua.indexOf('chrome') > -1) {
        // Chrome
        hasGeolocation = true;
      } else {
        // Safari
        // Geolocation on Safari won't work with mixed content
        hasGeolocation = false;
      }
    }
    this.hasGeolocation = hasGeolocation;

    // Initialize Group Control childern to match parent
    // this.groupControls.forEach((groupControl) => {
    //   this.navigationState.forEach((navControl) => {
    //     if (navControl.groupControlId === groupControl.id) {
    //       this.setNavigationActive({ id: navControl.id, active: groupControl.active });
    //       this.$bus.$emit('layer-visibility', navControl.id, groupControl.active);
    //     }
    //   });
    // });
  },

  methods: {
    ...mapActions([
      'setNavigationActive',
      'setReaderViewVisible',
      'setDrawerOpen',
      'setActiveNavigationSet',
      'setNavigation',
      'setNavigationZindex',
      'setNavigationOpacity',
    ]),

    linkto(pathname) {
      this.$router.push({ path: pathname });
    },

    toggleControl(control) {
      const active = !control.active;
      this.setNavigationActive({ id: control.id, active });
      // this.setMapLayerVisibility(id, active);
      this.$bus.$emit('layer-visibility', control.id, active, control.loadState);

      if (control.isGroupControl) {
        this.navigationState.forEach((navControl) => {
          if (navControl.groupControlId === control.id) {
            // this.setLayerVisibility(navControl.id, control.active);
            this.setNavigationActive({ id: navControl.id, active });
            this.$bus.$emit('layer-visibility', navControl.id, active, navControl.loadState);
          }
        });
      }
    },

    toggleSetControl(control) {
      if (this.activeNavigationSet === control.id) {
        this.setDrawerOpen(!this.isDrawerOpen);
        this.onResize();
      }

      if (this.activeNavigationSet !== control.id) {
        this.setNavigationActive({ id: this.activeNavigationSet, active: false });
        this.setActiveNavigationSet(control.id);
        this.setNavigationActive({ id: control.id, active: !control.active });

        // notPartOfNavigation
        // really needs to cache the previous navigation state for navigationSet going inactive
        // so we can restore the state when the user the user switches back
        // this.notPartOfNavigationSet.forEach((navControl) => {
        //   console.log(navControl.id);
        //   this.setNavigationActive({ id: navControl.id, active: false });
        //   this.$bus.$emit('layer-visibility', navControl.id, false);
        // });
      }
    },

    updateOpacity(id, opacity) {
      this.setNavigationOpacity({ id, opacity });
      this.$bus.$emit('update-layer-opacity', id, opacity);
    },

    onResize() {
      this.$bus.$emit('map-resize');
    },

    openReaderView() {
      this.setReaderViewVisible(true);
    },

    openAboutView() {
      this.$bus.$emit('open-about-view');
    },

    updateLayers() {
      this.$bus.$emit('update-layers-from-sources');
    },

    geoLocate() {
      this.isGeolocationError = false;
      this.isGeolocating = true;
      this.$bus.$emit('map-geolocate');
    },

    hasGeolocatedHandler() {
      this.isGeolocating = false;
    },

    geolocationErrorHandler(error) {
      console.log('geolocationErrorHandler', error);
      this.isGeolocationError = true;
    },

    // eslint-disable-next-line no-unused-vars
    onChange(evt) {
      this.navigationState.forEach((navControl, index) => {
        if (!navControl.isSetControl) {
          this.setNavigationZindex({ id: navControl.id, zindex: index });
        }
      });
      this.$bus.$emit('reorder-layers');
    },

    contextmenuHandler(event) {
      console.log(event);
      event.preventDefault();
      return false;
    },
  },

};
</script>

<style lang="less">
.rg-navigation {
  padding-bottom: 56px;
  .rg-list.horizontal {
    padding-top: 8px;
    padding-bottom: 0;
    flex-direction: row;
    position: relative;

    .rg-list-tile {
      flex: 0 0 90px;

      &.rg-tile-active {
        order: -1;
      }
    }
  }
}

.rg-tile {
  display: flex;
  flex-direction: column;
}
.rg-loader-icon{
  position: relative;
  flex: 0 0 90px;
  display: flex;
  flex-direction: column;
  white-space: normal;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.set-selector {
    position: absolute;
    left: 0;
    top: 16px;
    height: 24px;
    width: 24px;
    color: rgba(0, 0, 0, .6);
}

.rg-overlay{
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 25px;
  height: 40px;
  width: 40px;
}
.rg-loaded-icon{
  /* position: absolute; */
  z-index: 1;
  flex: 0 0 40px;
  width: 40px;
  overflow: hidden;
}


.rg-navigation-label {
  font-size: 14px;
  flex: 0 0 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 4px;
  max-width: 100%;
  // font-size: 10px;
  line-height: 14px;
  text-align: center;
  hyphens: auto;
  margin: 0;
  padding: 0 2px;
}
</style>
